import React from 'react'
import './ValidationMessage.css'

const ValidationMessage = ({ field, errors }) => {
    
    if(!errors || errors.length == 0) {
        return null
      }

      if(!errors[field]) {
        return null
      }
    
      return (
        <ul className="errors">
            {errors[field].map(error => <li className="error">{error}</li>)}
        </ul>
      )
}

export default ValidationMessage